import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { img2 } from "../../_components/Imagepath";
import FeatherIcon from "feather-icons-react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";

const Profile = () => {
  const [menu, setMenu] = useState(false);

  /* ================= AUTH COMPANY ================= */
  const [company, setCompany] = useState(null);

  useEffect(() => {
    const storedCompany = localStorage.getItem("company");
    if (!storedCompany) {
      window.location.href = "/login";
    } else {
      setCompany(JSON.parse(storedCompany));
    }
  }, []);

  /* ================= IMAGES (LOCAL ONLY) ================= */
  // const [profileImage, setProfileImage] = useState(
  //   localStorage.getItem("profileImage") || img2
  // );
  const [coverImage, setCoverImage] = useState(
    localStorage.getItem("coverImage") || "/assets/img/default-cover.jpg"
  );

  const toggleMobileMenu = () => setMenu(!menu);

const handleProfileImageChange = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    const base64Image = reader.result;

    const storedCompany = localStorage.getItem("company");
    if (!storedCompany) return;

    const company = JSON.parse(storedCompany);

    const updatedCompany = {
      ...company,
      photo_url: base64Image, // ✅ SINGLE SOURCE
    };

    localStorage.setItem("company", JSON.stringify(updatedCompany));
    setCompany(updatedCompany); // ✅ UI update
    window.dispatchEvent(new Event("storage"));
  };

  reader.readAsDataURL(file);
};




  const handleCoverImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setCoverImage(reader.result);
      localStorage.setItem("coverImage", reader.result);
    };
    reader.readAsDataURL(file);
  };

  /* ================= PROGRESS ================= */
  const calculateProgress = () => {
    if (!company) return 0;

    const fields = [
      company.email,
      company.contact_number,
      company.address,
      company.city,
      company.state,
      company.country,
    ];

    const filled = fields.filter(Boolean).length;
    return (filled / fields.length) * 100;
  };

  if (!company) return null;

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={toggleMobileMenu} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row justify-content-lg-center">
              <div className="col-lg-10">

                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header">
                    <h5>Profile</h5>
                  </div>
                </div>

                {/* Cover */}
                <div className="profile-cover">
                  <div className="profile-cover-wrap">
                    <img
                      className="profile-cover-img"
                      src={coverImage}
                      alt="Profile Cover"
                    />
                    <div className="cover-content">
                      <div className="custom-file-btn">
                        <input
                          type="file"
                          className="custom-file-btn-input"
                          id="cover_upload"
                          accept="image/*"
                          onChange={handleCoverImageChange}
                        />
                        <label
                          className="custom-file-btn-label btn btn-sm btn-white"
                          htmlFor="cover_upload"
                        >
                          <i className="fas fa-camera" />
                          <span className="d-none d-sm-inline-block ms-1">
                            Update Cover
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Profile Image */}
                <div className="text-center mb-5">
                  <label
                    className="avatar avatar-xxl profile-cover-avatar"
                    htmlFor="avatar_upload"
                  >
                   <img
  className="avatar-img"
  src={
    company?.photo_url
      ? company.photo_url.startsWith("data:")
        ? company.photo_url                 // ✅ base64 from DB
        : `http://localhost:5000/uploads/${company.photo_url}` // filename
      : img2
  }
  alt="Profile"
/>


                    <input
                      type="file"
                      id="avatar_upload"
                      onChange={handleProfileImageChange}
                    />
                    <span className="avatar-edit">
                      <FeatherIcon icon="edit" />
                    </span>
                  </label>

                  <h2>{company.company_name}</h2>

                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <i className="fas fa-map-marker-alt" />{" "}
                      {company.city}, {company.country}
                    </li>
                  </ul>
                </div>

                {/* Profile Completion */}
                <div className="card card-body mb-3">
                  <h5>Complete your profile</h5>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="progress progress-md flex-grow-1">
                      <div
                        className="progress-bar bg-primary"
                        style={{ width: `${calculateProgress()}%` }}
                      />
                    </div>
                    <span className="ms-3 fw-semibold">
                      {Math.round(calculateProgress())}%
                    </span>
                  </div>
                </div>

                {/* Details */}
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title d-flex justify-content-between">
                      <span>Profile</span>
                      <Link className="btn btn-sm btn-white" to="/settings">
                        Edit
                      </Link>
                    </h5>
                  </div>

                  <div className="card-body">
                    <ul className="list-unstyled mb-0">

                      <li className="mb-2">
                        <h6 className="text-muted">Contacts</h6>
                        <p className="mb-0">{company.email}</p>
                        <p className="mb-0">{company.contact_number}</p>
                      </li>

                      <hr />

                      <li>
                        <h6 className="text-muted">Address</h6>
                        <p className="mb-0">
                          {company.address}<br />
                          {company.city}<br />
                          {company.state}<br />
                          {company.country}
                        </p>
                      </li>

                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
